import { useCallback } from 'react';

import { client } from '../../../api/rest/client';
import { Actions } from '../../../constants/actionTypes';
import { toastErrorTranslated } from '../../../helpers/toast';
import { useMainDispatch } from '../../useMainDispatch';

export const useInboxActions = () => {
  const dispatch = useMainDispatch();

  const fetchInboxes = useCallback(async () => {
    try {
      dispatch({ type: Actions.SET_UI, payload: { isLoading: true } });
      const { data: inboxes } = await client.inbox.getAllInboxesOfCompany();
      dispatch({ type: Actions.SET_SETTINGS, payload: { inboxes } });
    } catch (error) {
      console.error(error);
      toastErrorTranslated(error);
    } finally {
      dispatch({ type: Actions.SET_UI, payload: { isLoading: false } });
    }
  }, [dispatch]);

  const createInbox = useCallback(
    async (inbox: any) => {
      try {
        dispatch({ type: Actions.SET_UI, payload: { isLoading: true } });
        await client.inbox.createInbox({ body: inbox });
        // TODO do not refetch
        await fetchInboxes();
      } catch (error) {
        console.error(error);
        toastErrorTranslated(error);
      } finally {
        dispatch({ type: Actions.SET_UI, payload: { isLoading: false } });
      }
    },
    [dispatch, fetchInboxes],
  );

  const editInbox = useCallback(
    async (inboxId: string, inboxData: any) => {
      try {
        dispatch({ type: Actions.SET_UI, payload: { isLoading: true } });
        await client.inbox.updateInbox({
          body: inboxData,
          params: { id: inboxId },
        });
        // TODO do not refetch
        await fetchInboxes();
      } catch (error) {
        console.error(error);
        toastErrorTranslated(error);
      } finally {
        dispatch({ type: Actions.SET_UI, payload: { isLoading: false } });
      }
    },
    [dispatch, fetchInboxes],
  );

  const deleteInbox = useCallback(
    async (inboxId: string) => {
      try {
        dispatch({ type: Actions.SET_UI, payload: { isLoading: true } });
        await client.inbox.deleteInbox({ params: { id: inboxId } });
        // TODO do not refetch
        await fetchInboxes();
      } catch (error) {
        console.error(error);
        toastErrorTranslated(error);
      } finally {
        dispatch({ type: Actions.SET_UI, payload: { isLoading: false } });
      }
    },
    [dispatch, fetchInboxes],
  );

  return {
    createInbox,
    editInbox,
    deleteInbox,
    fetchInboxes,
  };
};
